// // import "./RudrakshaSection.css";

// import { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// import vastuData from "../../data/vastuData";
// import ProductCard from "../RudrakshaSection/ProductCard";

// const banners = [
//   "https://i.pinimg.com/1200x/44/a0/7c/44a07c39eb28067cc068df1c44303b0c.jpg",
//   "https://i.pinimg.com/736x/45/eb/74/45eb74610608637f28926914d084b536.jpg",
//   "https://i.pinimg.com/1200x/5b/f6/fe/5bf6fec6a9d870e90cf9319c74dbf362.jpg",
// ];

// export default function VastuProductsSection() {
//   const tabs = Object.keys(vastuData);

//   const [activeTab, setActiveTab] = useState(tabs[0]);

//   return (
//     <section className="rudraksha-section">
//       <div className="container">
//         <div className="section-top">

//           <h2>Buy Premium Vastu Shashtra Products</h2>

//           <div className="tabs">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={activeTab === tab ? "active" : ""}
//                 onClick={() => setActiveTab(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="section-content">

//           <div className="left-banner">
//             <Swiper
//               modules={[Autoplay]}
//               loop
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//               }}
//             >
//               {banners.map((img, index) => (
//                 <SwiperSlide key={index}>
//                   <img src={img} alt="" />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>

//           <div className="right-products">
//              <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop={true}
//               spaceBetween={10}
//               slidesPerView={3}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 2,
//                   spaceBetween: 10,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                   spaceBetween: 12,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                   spaceBetween: 15,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                   spaceBetween: 20,
//                 },
//               }}
//             >
//               {vastuData[activeTab].map((product) => (
//                 <SwiperSlide key={product.id}>
//                   <ProductCard product={product} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }

// api integrated

import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const VASTU_CATEGORY_SLUG = "vastu-products";

const banners = [
  "https://i.pinimg.com/1200x/44/a0/7c/44a07c39eb28067cc068df1c44303b0c.jpg",
  "https://i.pinimg.com/736x/45/eb/74/45eb74610608637f28926914d084b536.jpg",
  "https://i.pinimg.com/1200x/5b/f6/fe/5bf6fec6a9d870e90cf9319c74dbf362.jpg",
];

export default function VastuProductsSection() {
  const [vastuCategory, setVastuCategory] = useState(null);

  const [subcategories, setSubcategories] = useState([]);

  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] = useState(true);

  const [loadingProducts, setLoadingProducts] = useState(false);

  useEffect(() => {
    const fetchVastuCategory = async () => {
      try {
        setLoadingCategories(true);

        // GET ALL CATEGORIES
        const result = await getCategories();

        console.log("All Categories:", result);

        if (!result?.success) {
          setVastuCategory(null);
          setSubcategories([]);

          return;
        }

        const categories = result?.data || [];

        const vastu = categories.find(
          (category) =>
            category?.slug?.toLowerCase() === VASTU_CATEGORY_SLUG.toLowerCase(),
        );

        console.log("Vastu Category:", vastu);

        if (!vastu) {
          console.error("Vastu category not found");

          setVastuCategory(null);
          setSubcategories([]);

          return;
        }

        setVastuCategory(vastu);

        if (Array.isArray(vastu.subcategories)) {
          setSubcategories(vastu.subcategories);
        } else {
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${vastu.id}/subcategories`,
          );

          const subResult = await subResponse.json();

          console.log("Vastu Subcategories:", subResult);

          if (subResult?.success) {
            setSubcategories(subResult.data || []);
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error("Vastu Category API Error:", error);

        setVastuCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchVastuCategory();
  }, []);

  const fetchAllProducts = async (categoryId) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,

        page: 1,

        limit: 12,
      });

      console.log("All Vastu Products:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Vastu Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchProductsBySubcategory = async (subcategoryId) => {
    try {
      if (!vastuCategory?.id || !subcategoryId) {
        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: vastuCategory.id,

        subcategoryId: subcategoryId,

        page: 1,

        limit: 12,
      });

      console.log("Vastu Products By Subcategory:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Vastu Subcategory Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (vastuCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(vastuCategory.id);
    }
  }, [vastuCategory]);

  const handleSubcategoryClick = (subcategory) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(subcategory.id);

    fetchProductsBySubcategory(subcategory.id);
  };

  const handleAllClick = () => {
    if (!vastuCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(vastuCategory.id);
  };

  return (
    <section className="rudraksha-section">
      <div className="container">
        <div className="section-top">
          <h2>Buy Premium Vastu Shashtra Products</h2>

          <div className="tabs">
            {/* ALL VASTU */}

            <button
              type="button"
              className={activeSubcategory === null ? "active" : ""}
              onClick={handleAllClick}
              disabled={loadingCategories || !vastuCategory}
            >
              All Vastu Products
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map((subcategory) => (
                <button
                  type="button"
                  key={subcategory.id}
                  className={
                    activeSubcategory === subcategory.id ? "active" : ""
                  }
                  onClick={() => handleSubcategoryClick(subcategory)}
                >
                  {subcategory.name}
                </button>
              ))}
          </div>
        </div>

        <div className="section-content">
          <div className="left-banner">
            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {banners.map((image, index) => (
                <SwiperSlide key={index}>
                  <img src={image} alt="Vastu Products" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="right-products">
            {loadingCategories || loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Vastu products..." size={56} />
              </div>
            ) : products.length === 0 ? (
              <div className="loading">No Vastu products found</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={products.length > 3}
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >
                {products.map((product) => (
                  <SwiperSlide key={product.id}>
                    <ProductCard product={product} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
